import { withModuleContext } from '@edreamsodigeo/frontend-core';
import { PrismaProvider } from '@edreamsodigeo/prisma-design-system';

const MODULE_NAMESPACE = 'price-freeze';

export const withPriceFreezeContext = withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});
